import path from 'node:path';
import { randomUUID } from 'node:crypto';
import { toJsonString } from '@wix/cli-fs';
import { componentGenerator } from '@wix/gena';
import {
  getDashboardPagesDir,
  DASHBOARD_PAGES_DIR,
} from '@wix/cli-app-definitions';
import type { DashboardPageConfig } from '@wix/cli-app-definitions';

// NOTE: path is relative to the build folder
const DASHBOARD_PAGE_TEMPLATE = path.resolve(
  __dirname,
  '../templates/dashboard-page'
);

export async function generateDashboardPage(
  projectFolder: string,
  route: string,
  title: string,
  categoryId?: string
) {
  const cwd = path.join(getDashboardPagesDir(projectFolder), route);

  const sidebarConfig: DashboardPageConfig['sidebar'] = categoryId
    ? { categoryId }
    : undefined;

  const pageConfig: DashboardPageConfig = {
    $schema: 'https://dev.wix.com/wix-cli/schemas/dashboard-page.json',
    id: randomUUID(),
    title,
    sidebar: sidebarConfig,
  };
  const pageConfigJSON = toJsonString(pageConfig, { spaces: 2 });
  const relativeRoutePath = path.join(DASHBOARD_PAGES_DIR, route, 'page.tsx');

  return await componentGenerator({
    template: DASHBOARD_PAGE_TEMPLATE,
    projectFolder,
    cwd,
    data: {
      route,
      title,
      relativeRoutePath,
      pageConfigJSON,
    },
  });
}
